import { render, staticRenderFns } from "./SubcategoriasProcessAdmin.vue?vue&type=template&id=461a15a2&scoped=true&"
import script from "./SubcategoriasProcessAdmin.vue?vue&type=script&lang=js&"
export * from "./SubcategoriasProcessAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SubcategoriasProcessAdmin.vue?vue&type=style&index=0&id=461a15a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461a15a2",
  null
  
)

export default component.exports